module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "printing-wrap"
  }, [_c('div', {
    staticClass: "printing"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "report-age-sex"
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.getPrintPageFirst.name))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getPrintPageFirst.userSex == 1 ? '女' : '男')
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getPrintPageFirst.userAge))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getPrintPageFirst.createtime))])])]), _vm._v(" "), _c('div', {
    staticClass: "report-mumber"
  }, [_c('p', [_vm._v("报告单号："), _c('b', [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))])])])]), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [_vm._m(4), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('div', {
    staticClass: "read-guid"
  }, [_c('p', [_vm._v("脑功能检测从描述静态结构转变为探讨动态脑功能网络，为您的脑功能进行精准分析，提供脑功能图谱及优劣势解读，及专业的个性化提升方案，为您的脑效率和脑健康保驾护航。")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('div', {
    staticClass: "read-guid"
  }, [_c('p', [_vm._v("10-16岁是大脑发育的重要阶段，此阶段孩子正处于从具体运算阶段（具体思维）到形式运算阶段（抽象思维）的关键阶段，脑功能检测可以探讨动态脑功能网络。本报告将根据检测结果，对您孩子的脑功能进行精准分析，提供脑功能图谱的优劣势解读和专业个性化提升方案，为孩子的脑效率和脑健康保驾护航。")])]) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('div', {
    staticClass: "read-prin"
  }, [_c('p', {
    staticClass: "read-prin-bot"
  }, [_vm._v("首先，检测结果受环境和个人状态影响，越安静的环境、越良好的状态，检测结果和您的实际情况越符合。")]), _vm._v(" "), _c('p', [_vm._v("其次，99.9%用户在检测项目的得分介于0-100之间，得分越高表明您的脑功能越好。得分与脑健康、脑效率对应关系，以及人数占比的对应关系见下表。")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('div', {
    staticClass: "read-prin"
  }, [_c('p', {
    staticClass: "read-prin-bot"
  }, [_vm._v("首先，检测结果受环境、大脑发育状态、个人状态影响。越安静的环境、发育越好的大脑、越良好的状态，检测结果和您孩子的实际情况越符合。值得注意的是，在10-16岁这一阶段，儿童大脑发育较快，且发育过程中不同脑功能发展的先后顺序存在个体差异，因此本报告中呈现的脑功能检测结果和分析，只是您孩子这一段时间内的状态，建议您从发展的角度看待孩子的脑功能状态，不要形成刻板印象。")]), _vm._v(" "), _c('p', [_vm._v("其次，99.9%用户在检测项目的得分介于0-100之间，得分越高表明您孩子的脑功能越好。得分与脑健康、脑效率对应关系，以及人数占比的对应关系见下表。")])]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "sore-table-title"
  }, [_vm._v("表 得分与脑功能表现、人数占比对应表")]), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('div', {
    staticClass: "read-table-bot"
  }, [_c('p', [_vm._v("最后，本报告包含了3个检测项目的结果，并提供整合分析和单项分析，可阅读综合检测结果和分项检测结果。")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('div', {
    staticClass: "read-table-bot"
  }, [_c('p', [_vm._v("最后，本报告包含了3个脑功能检测项目的结果，并根据孩子的结果提供综合分析和单项分析。您可按照顺序先阅读综合脑功能结果与解读，再阅读单项脑功能结果与解读。")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "toc-mulu"
  }, [_c('div', {
    staticClass: "zonghe-res"
  }, [_c('ul', [(_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin"
  }, [_vm._m(9)]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin-two"
  }, [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin Single"
  }, [_vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('li', {
    staticClass: "title-prin Single"
  }, [_vm._m(12)]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("2.1执行功能")])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.1执行功能")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('li', [(_vm.getshuzibijiao.brainEfficiency == '良好' || _vm.getshuzibijiao.brainEfficiency == '中等' || _vm.getshuzibijiao.brainEfficiency == '欠佳') ? _c('p', [_vm._v("2.1.3\n\t\t\t\t\t\t\t\t\t"), (_vm.getPrintPage.zhdx == 1) ? _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..............................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out5"
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.brainEfficiency == '出色') ? _c('p', [_vm._v("2.1.3\n\t\t\t\t\t\t\t\t\t"), (_vm.getPrintPage.zhdx == 1) ? _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势?")]) : _vm._e(), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out5"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('li', [(_vm.getshuzibijiao.brainEfficiency == '良好' || _vm.getshuzibijiao.brainEfficiency == '中等' || _vm.getshuzibijiao.brainEfficiency == '欠佳') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), (_vm.singleReport.status == 0) ? _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..............................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out5"
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.brainEfficiency == '出色') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), (_vm.singleReport.status == 0) ? _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势?")]) : _vm._e(), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                            ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out5"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.qinjingjiyi.status == 1) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("2.2情景记忆")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.qinjingjiyi.status == 1) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('li', [(_vm.qinjingjiyi.brainEfficiency == '良好' || _vm.qinjingjiyi.brainEfficiency == '中等' || _vm.qinjingjiyi.brainEfficiency == '欠佳') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t2.2.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.brainEfficiency == '出色') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t2.2.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.luojituili.status == 1) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("2.2图形推理")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.luojituili.status == 1) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('li', [(_vm.luojituili.brainEfficiency == '良好' || _vm.luojituili.brainEfficiency == '中等' || _vm.luojituili.brainEfficiency == '欠佳') ? _c('p', [_c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }), _vm._v("2.2.3提升方案\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...............................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.brainEfficiency == '出色') ? _c('p', [_c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }), _vm._v("2.2.3如何发挥优势？\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                            ...................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.1图形推理")])]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('li', [(_vm.luojituili.brainEfficiency == '良好' || _vm.luojituili.brainEfficiency == '中等' || _vm.luojituili.brainEfficiency == '欠佳') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t提升方案")]), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...............................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.brainEfficiency == '出色') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.2图形推理")])]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('li', [(_vm.luojituili.brainEfficiency == '出色') ? _c('p', [_c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }), _vm._v("1.2.3如何发挥优势？\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.brainEfficiency == '良好' || _vm.luojituili.brainEfficiency == '中等' || _vm.luojituili.brainEfficiency == '欠佳') ? _c('p', [_c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }), _vm._v("1.2.3提升方案\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                              ...............................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.1情景记忆")])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('li', [(_vm.qinjingjiyi.brainEfficiency == '良好' || _vm.qinjingjiyi.brainEfficiency == '中等' || _vm.qinjingjiyi.brainEfficiency == '欠佳') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t1.1.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.brainEfficiency == '出色') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t1.1.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.2情景记忆")])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('li', [(_vm.qinjingjiyi.brainEfficiency == '良好' || _vm.qinjingjiyi.brainEfficiency == '中等' || _vm.qinjingjiyi.brainEfficiency == '欠佳') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t1.2.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v("\n\t\t\t\t\t\t\t\t\t：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.brainEfficiency == '出色') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t1.2.3"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory4"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0 && _vm.jagongsport.status == 1 && _vm.luojituili.status == 0) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.1加工速度")])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0 && _vm.jagongsport.status == 1 && _vm.luojituili.status == 0) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('li', [(_vm.jagongsport.brainEfficiency == '良好' || _vm.jagongsport.brainEfficiency == '中等' || _vm.jagongsport.brainEfficiency == '欠佳') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v(":提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.brainEfficiency == '出色') ? _c('p', [_vm._v("1.1.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                           ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("1.2加工速度")])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _c('li', [(_vm.jagongsport.brainEfficiency == '良好' || _vm.jagongsport.brainEfficiency == '中等' || _vm.jagongsport.brainEfficiency == '欠佳') ? _c('p', [_vm._v("1.2.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v(":提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.brainEfficiency == '出色') ? _c('p', [_vm._v("1.2.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                            ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.jagongsport.status == 1) ? _c('li', {
    staticClass: "zhixing-small"
  }, [_c('p', [_vm._v("2.3加工速度")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.jagongsport.status == 1) ? _c('li', {
    staticClass: "title-prin-two zhixing"
  }, [_c('ul', [_vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('li', [(_vm.jagongsport.brainEfficiency == '良好' || _vm.jagongsport.brainEfficiency == '中等' || _vm.jagongsport.brainEfficiency == '欠佳') ? _c('p', [_vm._v("2.3.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("提升方案")]), _vm._v("：提供专业的提升脑功能方案\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ..................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.brainEfficiency == '出色') ? _c('p', [_vm._v("2.3.3\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("如何发挥优势？")]), _vm._v(" "), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .....................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed3"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin know-now"
  }, [_vm._m(35)]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "interesting"
  }, [_vm._m(36)]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('li', {
    staticClass: "title-prin know-now"
  }, [_vm._m(37)]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('li', {
    staticClass: "interesting"
  }, [_vm._m(38)]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('li', {
    staticClass: "title-prin last"
  }, [_vm._m(39)]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('li', {
    staticClass: "title-prin last"
  }, [_vm._m(40)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(41), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('div', {
    staticClass: "printing"
  }, [_vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('p', {
    staticClass: "score-Introduction"
  }, [_vm._v("\n\t\t\t\t您孩子的综合得分为"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.exceed) + "%")]), _vm._v("的人，处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.health))]), _vm._v("状态，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.efficiency))]), _vm._v("水平。以下是各项脑功能检测结果具体情况:\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('p', {
    staticClass: "score-Introduction"
  }, [_vm._v("\n\t\t\t\t您的综合得分为"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.exceed) + "%")]), _vm._v("的人，处于\n\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.health))]), _vm._v("状态，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.efficiency))]), _vm._v("水平。以下是各项脑功能检测结果具体情况:\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "table-title"
  }, [_vm._v("\n\t\t\t\t表1 脑功能检测结果表\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "printing-table"
  }, [_c('table', [_vm._m(44), _vm._v(" "), _vm._l((_vm.getscoreList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.gameName))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.correctNum))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.correctRate) + "%")]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.exceed) + "%")]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.brainFunction))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.brainEfficiency))]), _vm._v(" "), _c('td', {
      style: ({
        'color': _vm.color(item.brainHealth)
      })
    }, [_vm._v(_vm._s(item.brainHealth))])])
  })], 2)]), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('p', {
    staticClass: "coefficient-Interpretation"
  }, [_c('b', [_vm._v("系数解读:")]), _vm._v(" a. 反应时：用于反映个体信息加工时长，数字越小表明加工时间越短；b.红色字体表示您的该项脑功能处于不健康状态，蓝色字体表示您的该项脑功能处于亚健康状态。\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('p', {
    staticClass: "coefficient-Interpretation"
  }, [_c('b', [_vm._v("系数解读:")]), _vm._v(" a.反应时：用于反映个体信息加工时长，数字越小表明加工时间越短；b.红色字体表示您孩子的该项脑功能处于不健康状态，蓝色字体表示您孩子的该项脑功能处于亚健康状态。\n\t\t\t")]) : _vm._e(), _vm._v(" "), _vm._m(45), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('p', {
    staticClass: "brain-bot"
  }, [_vm._v("\n\t\t\t\t根据对您的数字比较任务、人物情景任务、数字符号转换任务这三项任务表现的综合分析，您的脑功能模式属于"), _c('span', [_vm._v(_vm._s(this.brainsuggest.brainType))]), _vm._v("。见图1:\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('p', {
    staticClass: "brain-bot"
  }, [_vm._v("\n\t\t\t\t根据对您孩子的数字比较任务、图形推理任务、数字符号转换任务这三项任务表现的综合分析，您孩子的脑功能模式属于"), _c('span', [_vm._v(_vm._s(this.brainsuggest.brainType))]), _vm._v("。见图1:\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "echart-barin"
  }, [_c('div', {
    style: ({
      width: '400px',
      height: '400px'
    }),
    attrs: {
      "id": "radarChart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brain-img-bot"
  }, [_vm._v("\n\t\t\t\t图1 脑功能图谱\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(46), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('div', {
    staticClass: "printing"
  }, [_vm._m(47), _vm._v(" "), _c('h6', {
    staticClass: "factor"
  }, [_vm._v("图谱解读")]), _vm._v(" "), _c('div', {
    staticClass: "map-inter"
  }, [_c('p', [_vm._v(_vm._s(_vm.brainsuggest.unscramble))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.reason))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(48), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('div', {
    staticClass: "printing"
  }, [_vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), (_vm.getPrintPage.isboy == 0) ? _c('div', {
    staticClass: "Synthesis-mind"
  }, [_c('p', [_vm._v("根据您的综合得分和脑功能图谱综合分析的结果，您的脑功能处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.efficiency))]), _vm._v("水平。")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.advice))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.prewarning))])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.isboy == 1) ? _c('div', {
    staticClass: "Synthesis-mind"
  }, [_c('p', [_vm._v("根据孩子的综合得分和脑功能图谱综合分析的结果，他／她的综合脑功能处于"), _c('span', [_vm._v(_vm._s(_vm.getPrintPage.efficiency))]), _vm._v("水平")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.advice))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.brainsuggest.prewarning))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(51), _vm._v(" "), _c('a', {
    staticClass: "page-num"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 1) ? _c('div', {
    staticClass: "Summarized"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t本次检测包含执行功能、逻辑推理和加工速度三项脑功能项目，以下是对您孩子的各项脑功能的测评结果及详细解读。\n\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 0) ? _c('div', {
    staticClass: "Summarized"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t本次检测包含执行功能、加工速度和情景记忆三项脑功能项目，以下是您的各项脑功能的测评结果及详细解读。\n\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('h3', {
    staticClass: "Summarized-Features"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/carried-out.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h3', {
    staticClass: "Summarized-Features"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/zhixing-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(52), _vm._v(" "), _c('div', {
    staticClass: "Summarized-res"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/jiantou.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.1.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.1 检测结果")]) : _vm._e()]), _vm._v(" "), (_vm.getshuzibijiao.isboy == 1) ? _c('div', {
    staticClass: "Summarized-Synthesis"
  }, [_c('p', [_vm._v("在数字比较任务中，我们设置了4个难度等级，如表"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v("。难度等级越高，表明需要您孩子投入的认知资源越多。")])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 0) ? _c('div', {
    staticClass: "Summarized-Synthesis"
  }, [_c('p', [_vm._v("在数字比较任务中，我们设置了4个难度等级，如表"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v("。难度等级越高，表明需要您投入的认知资源越多。")])]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "table-title"
  }, [_vm._v("\n\t\t\t\t表"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" 数字比较任务难度等级表\n\t\t\t")]), _vm._v(" "), _vm._m(53), _vm._v(" "), (_vm.getshuzibijiao.isboy == 1) ? _c('div', {
    staticClass: "tableindex"
  }, [_c('p', [_vm._v("通过各项指标计算，您孩子的执行功能得分为"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.agegroup))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.exceed))]), _vm._v("%\n\t\t\t\t的人，孩子的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.brainHealth))]), _vm._v("，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.brainEfficiency))]), _vm._v("水平。在正确率和反应时上的具体表现如下:")])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 0) ? _c('div', {
    staticClass: "tableindex"
  }, [_c('p', [_vm._v("通过各项指标计算，您的执行功能得分为"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.agegroup))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.exceed))]), _vm._v("%\n\t\t\t\t的人，您的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.brainHealth))]), _vm._v("，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.getshuzibijiao.brainEfficiency))]), _vm._v("水平。在正确率和反应时上的具体表现如下:")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(54), _vm._v(" "), _c('a', {
    staticClass: "page-num carried1"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "echart-performed-one"
  }, [_c('p', [_vm._v("（1）反应时上的表现。（图"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v("）")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-reaction-one",
    style: ({
      width: '700px',
      height: '450px'
    }),
    attrs: {
      "id": "histogram"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "difficulty"
  }, [_c('p', [_vm._v("难度等级")]), _vm._v(" "), _c('h6', [_vm._v("图 "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v("各难度等级的反应时")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-performed-two"
  }, [_c('p', [_vm._v("（2）正确率上的表现。（图"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v("）")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-reaction-two",
    style: ({
      width: '700px',
      height: '450px'
    }),
    attrs: {
      "id": "hisRight"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "difficulty"
  }, [_c('p', [_vm._v("难度等级")]), _vm._v(" "), _c('h6', [_vm._v("图 "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" 各难度等级的正确率")])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(55), _vm._v(" "), _c('a', {
    staticClass: "page-num carried2"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nerve"
  }, [(_vm.getshuzibijiao.isboy == 1) ? _c('p', [_vm._v("\n\t\t\t\t大量神经科学和临床研究表明，参与执行功能的脑区，主要包含双侧的背外侧前额叶、前扣带回等脑区，这些脑区以及它们之间的功能和结构连接被科学家们称作执行控制网络。根据您孩子在数字比较任务中的成绩可推测出孩子的执行功能脑网络状态" + _vm._s(_vm.getshuzibijiao.brainEfficiency) + "，如图\n\t\t\t\t"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v("。\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 0) ? _c('p', [_vm._v("\n\t\t\t\t\t大量神经科学和临床研究表明，参与执行功能的脑区，主要包含双侧的背外侧前额叶、前扣带回等脑区，这些脑区以及它们之间的功能和结构连接被科学家们称作执行控制网络。根据您在数字比较任务中的成绩可推测出您执行控制网络状态" + _vm._s(_vm.getshuzibijiao.brainEfficiency) + "，如图\n\t\t\t\t\t"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v("。\n\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "brain-figure"
  }, [(_vm.getshuzibijiao.cid == 4) ? _c('img', {
    attrs: {
      "src": require("../assets/naoz-1.png"),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.cid == 3) ? _c('img', {
    attrs: {
      "src": require("../assets/naoz-2.png"),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.cid == 2) ? _c('img', {
    attrs: {
      "src": require("../assets/naoz-3.png"),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.cid == 1) ? _c('img', {
    attrs: {
      "src": require("../assets/naoz-4.png"),
      "alt": "图片"
    }
  }) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "brain-des"
  }, [_vm._v("图"), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v("执行功能脑网络图")]), _vm._v(" "), _c('div', {
    staticClass: "six-res"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/jiantou.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.1.2六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.2六六脑解读")]) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-effec"
  }, [_vm._v("执行功能与脑效率、脑健康")]), _vm._v(" "), _c('div', {
    staticClass: "nao-hel"
  }, [_c('p', [_vm._v(_vm._s(_vm.getshuzibijiao.efficiency))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(56), _vm._v(" "), _c('a', {
    staticClass: "page-num carried3"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "carried-out"
  }, [_vm._v("影响执行功能的因素")]), _vm._v(" "), (_vm.getshuzibijiao.isboy == 0) ? _c('div', {
    staticClass: "carried-sport"
  }, [_c('p', [_vm._v("缺乏运动、睡眠不足、不良生活习惯、脑疲劳或脑损伤等都是导致个体执行功能不好的原因。研究表明，运动能促进细胞内的线粒体和细胞产生能量，长期缺乏运动可能会导致大脑皮层的供养不足，脑区之间的相互连接减弱，进而导致了执行功能的下降；大脑长期处于疲劳和亚健康状态，导致的反应能力降低，也是引起执行功能下降的原因之一。《美国医学会杂志》曾刊载过一项研究，大脑在25岁发育达到顶峰，30岁后大脑便开始逐渐衰老，每年缩小0.3%，人体新陈代谢也随之逐渐变缓。而长期睡眠不足、用脑习惯不好，学习、工作压力过大，都会导致大脑的疲劳，导致执行功能降低。此外，脑损伤、脑疾病、躯体问题等任何引起大脑皮层功能和结构异常的因素均会引起执行功能的下降。执行功能障碍常见于额叶-皮质下环路受损，执行功能良好的基础是大脑皮层的正常功能，躯体疾病和脑疾病会引起神经活动的异常，损伤大脑结构和功能，造成执行功能的下降。")])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.isboy == 1) ? _c('div', {
    staticClass: "carried-sport"
  }, [_c('p', [_vm._v("缺乏运动、睡眠不足、不良生活习惯、脑疲劳或大脑发育不良等都是导致个体执行功能不好的原因。研究表明，运动能促进细胞内的线粒体和细胞产生能量，长期缺乏运动可能会导致大脑皮层的供养不足，脑区之间的相互连接减弱，进而导致了执行功能的下降。Friedman等研究者们对916名双胞胎进行随访研究，结果发现儿童的睡眠问题与青春期的执行控制功能相关，孩子对睡眠的生理需要量多余成人，睡眠不足对孩子执行功能的损害尤为突出，具体表现为计划性差、思维僵化、注意力不足、多动、冲动和情绪多变；大脑长期处于疲劳和亚健康状态，导致的反应能力降低，也是引起执行功能下降的原因之一。此外，与执行功能相对应的执行控制网络，在整个儿童和青少年时期都是不断发展的，各种原因引起的神经系统发育不良，尤其是执行控制网络对应大脑皮层功能和结构发育不良，会导致执行功能上的表现较差。")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(57), _vm._v(" "), _c('a', {
    staticClass: "page-num carried4"
  })])]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "enhance-pro"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/jiantou.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getshuzibijiao.brainEfficiency == '良好' || _vm.getshuzibijiao.brainEfficiency == '中等' || _vm.getshuzibijiao.brainEfficiency == '欠佳') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.1.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3 提升方案")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.brainEfficiency == '出色') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.1.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3如何发挥优势？")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.getshuzibijiao.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.shuzibijiaoList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(58), _vm._v(" "), _c('a', {
    staticClass: "page-num carried5"
  })])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/scene.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.jagongsport.status == 0 && _vm.singleReport.status == 0) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/qingjing-one-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/qingjign-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(59), _vm._v(" "), _c('div', {
    staticClass: "scene-res"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/jiantou.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.1 检测结果")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "Detection-res"
  }, [_c('p', [_vm._v("本检测项目通过回忆人像与地点、事件的联结记忆考察情景记忆，共进行两次学习-回忆。")]), _vm._v(" "), _c('p', [_vm._v("通过两次记忆核算，您的情景记忆得分为"), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.exceed))]), _vm._v("%的人，您的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.brainHealth))]), _vm._v("，脑效率处于"), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.brainEfficiency))]), _vm._v("水平。两次记忆情况具体如下:")])]), _vm._v(" "), _c('h6', {
    staticClass: "table-title"
  }, [_vm._v("\n\t\t\t\t情景记忆检测结果\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "Detection-table"
  }, [_c('table', [_vm._m(60), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rowspan-td",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("第一次")]), _vm._v(" "), _c('td', [_vm._v("人像地点联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate1) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("人像事件联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate2) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("人像地点事件联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta3))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate3) + "%")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rowspan-td",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("第二次")]), _vm._v(" "), _c('td', [_vm._v("人像地点联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta4))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate4) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("人像事件联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta5))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate5) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("人像地点事件联结")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.righta6))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qinjingjiyi.rightaRate6) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(61), _vm._v(" "), _c('a', {
    staticClass: "page-num scene1"
  })])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nerv-show"
  }, [_c('p', [_vm._v("大量神经科学和临床研究表明，参与情景记忆的脑区，主要包含内侧前额叶、后扣带/楔前叶、角回、海马等。根据您在人物情景中的成绩可推测出您情景记忆网络状态"), _c('span', [_vm._v(_vm._s(_vm.qinjingjiyi.brainEfficiency))]), _vm._v("，如图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v("。")])]), _vm._v(" "), _c('div', {
    staticClass: "nao-memory"
  }, [(_vm.qinjingjiyi.cid == 4) ? _c('img', {
    attrs: {
      "src": require("../assets/naoq-1.png"),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.cid == 3) ? _c('img', {
    attrs: {
      "src": require("../assets/naoq-2.png"),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.cid == 2) ? _c('img', {
    attrs: {
      "src": require("../assets/naoq-3.png"),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.cid == 1) ? _c('img', {
    attrs: {
      "src": require("../assets/naoq-4.png"),
      "alt": "图片"
    }
  }) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-memory-bot"
  }, [_vm._v("图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v(" 情景记忆脑网络图")]), _vm._v(" "), _c('div', {
    staticClass: "enhance-pro"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/jiantou.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.2 六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.2 六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.2 检测结果")]) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-enhance"
  }, [_vm._v("情景记忆与脑效率、脑健康")]), _vm._v(" "), _c('div', {
    staticClass: "memory-error"
  }, [_c('p', [_vm._v(_vm._s(_vm.qinjingjiyi.efficiency))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(62), _vm._v(" "), _c('a', {
    staticClass: "page-num scene2"
  })])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "factor"
  }, [_vm._v("影响情景记忆的因素")]), _vm._v(" "), _vm._m(63), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(64), _vm._v(" "), _c('a', {
    staticClass: "page-num scene3"
  })])]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "play-adv"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/jiantou.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.qinjingjiyi.brainEfficiency == '良好' || _vm.qinjingjiyi.brainEfficiency == '中等' || _vm.qinjingjiyi.brainEfficiency == '欠佳') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.3 提升方案")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.brainEfficiency == '出色') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.qinjingjiyi.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.3如何发挥优势？")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.qinjingjiyi.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sanjaio-bot"
  }), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.renwuqingjign), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(65), _vm._v(" "), _c('a', {
    staticClass: "page-num scene4"
  })])]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/lj-talent.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tuxing-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.singleReport.status == 0 && _vm.getshuzibijiao.status == 1) ? _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tuxin-tw.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(66), _vm._v(" "), _c('div', {
    staticClass: "scene-res"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/jiantou.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.1 检测结果")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "Summarized-Synthesis"
  }, [_c('p', [_vm._v("在图形推理任务中，我们设置了5个难度等级。难度等级越高，表明需要您孩子投入的认知资源越多，表\n\t\t\t\t"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v("。")])]), _vm._v(" "), _c('h6', {
    staticClass: "table-title"
  }, [_vm._v("\n\t\t\t\t表\n\t\t\t\t"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v("图形推理任务各难度等级测试结果\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "Rating-table-luoji"
  }, [_c('table', [_vm._m(67), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("知识辨别")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.luojituili.right1) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("类同比较")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.luojituili.right2) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("比较推理")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.luojituili.right3) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("系列关系")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.luojituili.right4) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("抽象推理")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.luojituili.right5) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "Detection-res"
  }, [_c('p', [_vm._v("通过各项指标计算，您孩子的逻辑推理得分为"), _c('span', [_vm._v(_vm._s(_vm.luojituili.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.luojituili.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.luojituili.exceed))]), _vm._v("%的人，孩子的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.luojituili.brainHealth))]), _vm._v("，脑效率处"), _c('span', [_vm._v(_vm._s(_vm.luojituili.brainEfficiency))]), _vm._v("水平。在正确率和反应时的具体表现如下：")])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(68), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic1"
  })])]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "echart-performed-one"
  }, [_c('p', [_vm._v("（1）反应时上的表现。（图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v("）")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-reaction-one",
    style: ({
      width: '700px',
      height: '450px'
    }),
    attrs: {
      "id": "Graphics"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "difficulty"
  }, [_c('p', [_vm._v("难度等级")]), _vm._v(" "), _c('h6', [_vm._v("图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v(" 各难度等级的反应时")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-performed-two"
  }, [_c('p', [_vm._v("（2）正确率上的表现。（图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v("）")])]), _vm._v(" "), _c('div', {
    staticClass: "echart-reaction-two",
    style: ({
      width: '700px',
      height: '450px'
    }),
    attrs: {
      "id": "reasoning"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "difficulty"
  }, [_c('p', [_vm._v("难度等级")]), _vm._v(" "), _c('h6', [_vm._v("图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("5")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v(" 各难度等级的正确率")])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(69), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic2"
  })])]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nerve"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t逻辑推理涉及的脑网络为额顶整合网络（parieto-frontal integration theory, P-FIT），在个体中，逻辑推理能力涉及脑区为背外侧前额叶、后顶叶、前扣带、脑岛等。这些脑区以及它们之间的功能和结构连接被科学家们称作执行控制网络、注意网络和外显网络。根据您孩子在图形推理任务中的成绩可推测出孩子的逻辑推理脑网络状态"), _c('span', [_vm._v(_vm._s(_vm.luojituili.brainEfficiency))]), _vm._v("，如图7。\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "brain-figure"
  }, [(_vm.luojituili.cid == 4) ? _c('img', {
    attrs: {
      "src": require("../assets/naol-1.png"),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.luojituili.cid == 3) ? _c('img', {
    attrs: {
      "src": require("../assets/naol-2.png"),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.luojituili.cid == 2) ? _c('img', {
    attrs: {
      "src": require("../assets/naol-3.png"),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.luojituili.cid == 1) ? _c('img', {
    attrs: {
      "src": require("../assets/naol-4.png"),
      "alt": "图片"
    }
  }) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "brain-des"
  }, [_vm._v("图"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("3")]) : _vm._e(), _vm._v(" "), (_vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 1) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('span', [_vm._v("7")]) : _vm._e(), _vm._v(" 逻辑推理脑网络图")]), _vm._v(" "), _c('div', {
    staticClass: "six-res"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/jiantou.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.2六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.2六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.2 六六脑解读")]) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-effec"
  }, [_vm._v("逻辑推理与脑效率、脑健康")]), _vm._v(" "), _c('div', {
    staticClass: "nao-hel"
  }, [_c('p', [_vm._v(_vm._s(_vm.luojituili.efficiency))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(70), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic3"
  })])]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "carried-out"
  }, [_vm._v("影响逻辑推理的因素")]), _vm._v(" "), _vm._m(71), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(72), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic4"
  })])]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "play-adv"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/jiantou.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.luojituili.brainEfficiency == '良好' || _vm.luojituili.brainEfficiency == '中等' || _vm.luojituili.brainEfficiency == '欠佳') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3提升方案")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.3提升方案")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.luojituili.brainEfficiency == '出色') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.2.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.1.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && _vm.getshuzibijiao.status == 1 && _vm.singleReport.status == 0) ? _c('a', [_vm._v("1.2.3如何发挥优势？")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.luojituili.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [(this.tuxintuiliList.length <= 4) ? _c('table', _vm._l((_vm.tuxintuiliList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  })) : _vm._e(), _vm._v(" "), (this.tuxintuiliList.length > 4) ? _c('table', _vm._l((_vm.luojituiliList1), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(73), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic5"
  })])]) : _vm._e(), _vm._v(" "), (this.tuxintuiliList.length > 4) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.luojituili.status == 1 && 　_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.luojituiliList2), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(74), _vm._v(" "), _c('a', {
    staticClass: "page-num graphic5"
  })])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('div', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/speed.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('div', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/jiagong-two.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('div', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/jia-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.isboy == 0) ? _c('div', {
    staticClass: "scene-intr"
  }, [_c('p', [_vm._v("加工速度（Processing speed）是指人脑对信息的获取、存储、加工和使用的过程所需的时间。它实质上反应了认知过程的内部心理机制的变化过程。")])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.isboy == 1) ? _c('div', {
    staticClass: "scene-intr"
  }, [_c('p', [_vm._v("加工速度（Processing speed）是指个体吸收信息、处理信息、记忆信息和提取信息的快慢。加工速度主要涉及的脑网络是感觉运动网络（包括中央前回和中央后回等脑区）和注意网络（包含后顶叶等脑区）。它实质上反应了认知过程的内部心理机制的变化过程。例如，在接触新事物和学习新知识时，加工速度好的人，能很快适应新事物，找到学习的关键点，给人以“聪明灵敏”的感觉。数字符号转换 （Digital Symbol Substitution）选自韦氏智力测验的分测验（Wechsler, 1958），通过计算数字和特殊符号匹配的反应时和正确率来检测个体的速度，被广泛地用于个体加工速度的评估。该范式被广泛地应用于很多神经心理测验中作为评估个体心理发展水平的重要工具。")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "play-adv"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/jiantou.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.3.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('a', [_vm._v("1.2.1 检测结果")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('a', [_vm._v("1.1.1 检测结果")]) : _vm._e()]), _vm._v(" "), (_vm.jagongsport.isboy == 0) ? _c('div', {
    staticClass: "Detection-res"
  }, [_c('p', [_vm._v("通过各项指标计算，您的加工速度得分为"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.jagongsport.exceed))]), _vm._v("%的人，您的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainHealth))]), _vm._v("，脑效率处"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainEfficiency))]), _vm._v("水平。")]), _vm._v(" "), _c('p', [_vm._v("大量神经科学和临床研究表明，参与加工速度的脑区，主要包含中央前回，中央后回、后顶叶等。根据您在数字符号转换任务中的成绩可推测出您加工速度脑网络"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainEfficiency))]), _vm._v("。如图6。")])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.isboy == 1) ? _c('div', {
    staticClass: "Detection-res"
  }, [_c('p', [_vm._v("在数字符号转换任务中，孩子在一定时间内答对测试题目的个数越多，即孩子反应速度越快，得分越高，在反应时上的具体表现如表1。通过各项指标计算，您的孩子加工速度得分为"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.score))]), _vm._v("，超过所处年龄段"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.agegroup))]), _c('span', [_vm._v(_vm._s(_vm.jagongsport.exceed))]), _vm._v("%的人，孩子的此项脑功能"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainHealth))]), _vm._v("，脑效率处"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainEfficiency))]), _vm._v("水平.")]), _vm._v(" "), _c('p', [_vm._v("大量神经科学和临床研究表明，参与加工速度的脑区，主要包含中央前回、中央后回、后顶叶等。这些脑区以及它们之间的功能和结构连接被科学家们称作感觉运动网络和注意网络。根据您孩子在数字符号转换任务中的成绩可推测出孩子加工速度脑网络状态"), _c('span', [_vm._v(_vm._s(_vm.jagongsport.brainEfficiency))]), _vm._v("。如图\n\t\t\t\t"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.luojituili.status == 0 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.getshuzibijiao.status == 1 && _vm.qinjingjiyi.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.getshuzibijiao.status == 1 && _vm.luojituili.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("8")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.getshuzibijiao.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), _vm._v("。\n\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nao-memory"
  }, [(_vm.jagongsport.cid == 4) ? _c('img', {
    attrs: {
      "src": require("../assets/naoj-1.png"),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jagongsport.cid == 3) ? _c('img', {
    attrs: {
      "src": require("../assets/naoj-2.png"),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jagongsport.cid == 2) ? _c('img', {
    attrs: {
      "src": require("../assets/naoj-3.png"),
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jagongsport.cid == 1) ? _c('img', {
    attrs: {
      "src": require("../assets/naoj-4.png"),
      "alt": "图片"
    }
  }) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-memory-bot"
  }, [_vm._v("图\n\t\t\t\t"), (_vm.getshuzibijiao.status == 0 && _vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.luojituili.status == 0 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.getshuzibijiao.status == 1 && _vm.qinjingjiyi.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("6")]) : _vm._e(), _vm._v(" "), (_vm.getPrintPage.zhdx == 1 && _vm.getshuzibijiao.status == 1 && _vm.luojituili.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("8")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.getshuzibijiao.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.qinjingjiyi.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0 && _vm.luojituili.status == 1 && _vm.jagongsport.status == 1) ? _c('span', [_vm._v("4")]) : _vm._e(), _vm._v(" "), _vm._v("\n\t\t\t\t加工速度脑网络图")]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(75), _vm._v(" "), _c('a', {
    staticClass: "page-num processing1"
  })])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "enhance-pro"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/jiantou.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.3.2 六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('a', [_vm._v("1.2.2 六六脑解读")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('a', [_vm._v("1.1.2 六六脑解读")]) : _vm._e()]), _vm._v(" "), _c('h6', {
    staticClass: "nao-enhance"
  }, [_vm._v("加工速度与脑效率、脑健康")]), _vm._v(" "), _c('div', {
    staticClass: "memory-error"
  }, [_c('p', [_vm._v(_vm._s(_vm.jagongsport.efficiency))])]), _vm._v(" "), _c('h6', {
    staticClass: "factor"
  }, [_vm._v("影响加工速度的因素")]), _vm._v(" "), (_vm.jagongsport.isboy == 1) ? _c('div', {
    staticClass: "age-factor"
  }, [_c('p', [_vm._v("神经脉冲速度、个体精神和情绪状态、知识和兴趣等都会影响个体加工速度。研究表明，人的思维是一种脉冲，它沿着人体的神经纤维运行，速度大约是每小时250公里，但是每一个人的神经系统在传送信号脉冲时，都有速度的差别，这就是为什么有些人反应快，有些人反应慢。同时，反应快慢还与人的精神状态有关系，如果心情愉快，放松，人体处于舒服的状态，自然就反应很快。最近发表在Intensive Care Med的一项研究结果表明，值夜班后，医生的信息处理速度会有所下降，因此，睡眠充足也是保证反应灵敏的重要生理基础。此外，反应的敏捷与否，是可以通过心理调适来改变的。一般来说，人们对于兴趣浓厚的事物，往往容易引起敏捷反应，同样是学习新课程，你感兴趣的科目，学习的效率会更高；同样是一份作业，孩子感兴趣的作业，投入的注意力更集中，做的效率会更高。")])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.isboy == 0) ? _c('div', {
    staticClass: "age-factor"
  }, [_c('p', [_vm._v("神经脉冲速度（生理因素）、个体精神和情绪状态、知识和兴趣等都会影响个体加工速度。研究表明，人的思维是一种脉冲，它沿着人体的神经纤维运行，速度大约是每小时250公里，但是每一个人的神经系统在传送信号脉冲时，都有速度的差别，这就是为什么有些人反应快，有些人反应慢。同时，反应快慢还与人的精神状态有关系，如果心情愉快，放松，人体处于舒服的状态，自然就反应很快。最近发表在Intensive Care Med的一项研究结果表明，值夜班后，医生的信息处理速度会有所下降，因此，睡眠充足也是保证反应灵敏的重要生理基础。此外，反应的敏捷与否，是可以通过心理调适来改变的。一般来说，人们对于兴趣浓厚的事物，往往容易引起敏捷反应，同样是学习新课程，你感兴趣的科目，学习的效率会更高；同样是一份工作，您感兴趣的工作，投入的注意力更集中，做的效率会更高。")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(76), _vm._v(" "), _c('a', {
    staticClass: "page-num processing2"
  })])]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "play-adv"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/jiantou.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), (_vm.jagongsport.brainEfficiency == '良好' || _vm.jagongsport.brainEfficiency == '中等' || _vm.jagongsport.brainEfficiency == '欠佳') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.3.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('a', [_vm._v("1.2.3 提升方案")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('a', [_vm._v("1.1.3 提升方案")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.brainEfficiency == '出色') ? _c('a', [(_vm.getPrintPage.zhdx == 1) ? _c('a', [_vm._v("2.3.3如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && (_vm.luojituili.status == 1 || _vm.qinjingjiyi.status == 1 || _vm.getshuzibijiao.status == 1)) ? _c('a', [_vm._v("1.2.3 如何发挥优势？")]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0 && _vm.luojituili.status == 0 && _vm.qinjingjiyi.status == 0 && _vm.getshuzibijiao.status == 0) ? _c('a', [_vm._v("1.1.3 如何发挥优势？")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "Suggest"
  }, [_vm._v(_vm._s(_vm.jagongsport.advice))]), _vm._v(" "), _c('div', {
    staticClass: "sanjaio-bot"
  }), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [(this.jiagongsuduList.length <= 4) ? _c('table', _vm._l((_vm.jiagongsuduList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  })) : _vm._e(), _vm._v(" "), (this.jiagongsuduList.length > 4) ? _c('table', _vm._l((_vm.jiagongsuduList1), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(77), _vm._v(" "), _c('a', {
    staticClass: "page-num processing3"
  })])]) : _vm._e(), _vm._v(" "), (this.jiagongsuduList.length > 4) ? _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/even-map.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.jagongsport.status == 1 && _vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/danxiag-one.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sport-table"
  }, [_c('table', _vm._l((_vm.jiagongsuduList2), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.advice))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(78), _vm._v(" "), _c('a', {
    staticClass: "page-num processing3"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/you-know.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/youknow-two.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "printing-left"
  }, [(_vm.getTalentyou.id == 1) ? _c('img', {
    attrs: {
      "src": require("../assets/memory-talent.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getTalentyou.id == 2) ? _c('img', {
    attrs: {
      "src": require("../assets/luoji-talent.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getTalentyou.id == 3) ? _c('img', {
    attrs: {
      "src": require("../assets/linhuo-talent.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getTalentyou.id == 4) ? _c('img', {
    attrs: {
      "src": require("../assets/yanyu-talent.png")
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "memory-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.getTalentyou.userUrl,
      "alt": "图片"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "age-factor"
  }, [_c('p', [_vm._v(_vm._s(_vm.getTalentyou.introduction))])]), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(79), _vm._v(" "), _c('a', {
    staticClass: "page-num know"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "printing"
  }, [(_vm.getPrintPage.zhdx == 1) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/postscript.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.singleReport.status == 0) ? _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/houji-two.png"),
      "alt": "图片"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.isboy == 0) ? _c('div', {
    staticClass: "Follow-up"
  }, [_c('p', [_vm._v("1、任一脑功能都是十分复杂的，无论多好的检测项目都无法完全评价您的脑功能，但科学检测是深入了解脑功能的一扇门。")]), _vm._v(" "), _c('p', [_vm._v("2、检测结果受环境和个人状态影响，越安静的环境、越良好的状态，都可能会使您的结果更真实。")]), _vm._v(" "), _c('p', [_vm._v("3、本检测主要用于评估您的基础脑功能，如果您想用于评价个人能力和职业发展，建议结合职业、性格等测试。此外，越全面的脑功能用于评价个人能力和职业发展的效度越高。")])]) : _vm._e(), _vm._v(" "), (_vm.getPrintPageFirst.isboy == 1) ? _c('div', {
    staticClass: "Follow-up"
  }, [_c('p', [_vm._v("1、任一脑功能都是十分复杂的，无论多好的检测项目都无法完全评价孩子的脑功能，但科学检测是深入了解脑功能的一扇门。")]), _vm._v(" "), _c('p', [_vm._v("2、检测结果受环境和个人状态影响，越安静的环境、越良好的状态，都可能会使孩子的结果更真实。")]), _vm._v(" "), _c('p', [_vm._v("3、儿童和青少年时期处于脑功能发展的关键阶段，孩子的脑功能水平会随着年龄的增长而不断变化。因此，本次脑功能检测，只代表孩子现在所处年龄段的水平，建议您持续关注孩子的脑健康和脑效率。")]), _vm._v(" "), _c('p', [_vm._v("4、本检测主要用于评估孩子的基础脑功能，如果您想用于评价孩子的个人能力和学业能力发展，建议结合专业的人格、成就等测试。此外，越全面的脑功能检测，用于评价个人能力和学业能力发展的效度越高。")])]) : _vm._e(), _vm._v(" "), _vm._m(80), _vm._v(" "), _c('div', {
    staticClass: "page-Increment"
  }, [_c('a', {
    staticClass: "page-size"
  }, [_vm._v(_vm._s(_vm.getPrintPageFirst.cpNumber))]), _vm._v(" "), _vm._m(81), _vm._v(" "), _c('a', {
    staticClass: "page-num postscript"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "closePrint",
    attrs: {
      "href": "javascript:;",
      "title": "打印"
    },
    on: {
      "click": function($event) {
        _vm.print_page()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "closePage",
    attrs: {
      "href": "javascript:;",
      "title": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.print_close()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "moveUp",
    attrs: {
      "href": "javascript:;",
      "title": "回到顶部"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-corver"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/report-logo.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-dete"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/report-size.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-naologo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/report-corver.png"),
      "alt": "logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("姓名:")]), _vm._v(" "), _c('li', [_vm._v("性别:")]), _vm._v(" "), _c('li', [_vm._v("年龄:")]), _vm._v(" "), _c('li', [_vm._v("日期:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/read-guid.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/read-prin.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "read-table"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("得分")]), _vm._v(" "), _c('th', [_vm._v("脑健康")]), _vm._v(" "), _c('th', [_vm._v("脑效率")]), _vm._v(" "), _c('th', [_vm._v("人数占比")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[75~100"), _c('span', {
    staticClass: "numjia"
  }, [_vm._v("＋")])]), _vm._v(" "), _c('td', [_vm._v("健康")]), _vm._v(" "), _c('td', [_vm._v("出色")]), _vm._v(" "), _c('td', [_vm._v("6%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[60~75)")]), _vm._v(" "), _c('td', [_vm._v("健康")]), _vm._v(" "), _c('td', [_vm._v("良好")]), _vm._v(" "), _c('td', [_vm._v("24%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[25-60)")]), _vm._v(" "), _c('td', [_vm._v("亚健康")]), _vm._v(" "), _c('td', [_vm._v("中等")]), _vm._v(" "), _c('td', [_vm._v("64%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("[0-25)")]), _vm._v(" "), _c('td', [_vm._v("不健康")]), _vm._v(" "), _c('td', [_vm._v("欠佳")]), _vm._v(" "), _c('td', [_vm._v("6%")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/table-co.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("1.综合脑功能结果与解读\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("..............................................................")]), _vm._v(" "), _c('span', [_vm._v("03")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('p', [_vm._v("1.1检测结果全貌\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t ..........................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', [_vm._v("03")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("1.2脑功能图谱：分析脑功能特点、优劣势及在生活的表现\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ...........................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', [_vm._v("03")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("1.3综合建议：解读如何根据脑功能特点扬长避短\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .........................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', [_vm._v("05")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("2.单项脑功能结果与解读\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("...............................................................")]), _vm._v(" "), _c('span', {
    staticClass: "out1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("1.单项脑功能结果与解读\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("...............................................................")]), _vm._v(" "), _c('span', {
    staticClass: "out1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.1.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.1.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .....................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .....................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "out4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.2.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t....................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.2.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                               .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.2.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.2.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                               .....................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                                 .....................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                               .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "reasoning3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                               .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                               .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "memory3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t  ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.1.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t  ..................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("1.2.2六六脑解读:分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             .......................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.3.1单项脑功能结果\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t  .....................................................................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed1"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', [_vm._v("2.3.2六六脑解读：分析脑功能在生活的表现及原因\n\t\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t\t                             ........................................................\n\t\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "speed2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("3.您知道吗？\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("..................................................................................")]), _vm._v(" "), _c('span', {
    staticClass: "understanding"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("有趣案例：分析名人某项优势脑功能\n\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t                             ...............................................................................\n\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "understanding"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("2.您知道吗？\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("..................................................................................")]), _vm._v(" "), _c('span', {
    staticClass: "understanding"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("有趣案例：分析名人某项优势脑功能\n\t\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("\n\t                             ................................................................................\n\t\t\t\t\t\t\t\t ")]), _vm._v(" "), _c('span', {
    staticClass: "understanding"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("4.后记\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v(".............................................................................................")]), _vm._v(" "), _c('span', {
    staticClass: "lastpostscript"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("3.后记\n\t\t\t\t\t\t\t"), _c('b', {
    staticClass: "dast-xian"
  }, [_vm._v("..............................................................................................")]), _vm._v(" "), _c('span', {
    staticClass: "lastpostscript"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/title-header.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "printing-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/title-left.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("检测项目")]), _vm._v(" "), _c('th', [_vm._v("题目数")]), _vm._v(" "), _c('th', [_vm._v("正确数")]), _vm._v(" "), _c('th', [_vm._v("正确率")]), _vm._v(" "), _c('th', [_vm._v("反应时")]), _vm._v(" "), _c('th', [_vm._v("得分")]), _vm._v(" "), _c('th', [_vm._v("超过")]), _vm._v(" "), _c('th', [_vm._v("脑功能")]), _vm._v(" "), _c('th', [_vm._v("脑效率")]), _vm._v(" "), _c('th', [_vm._v("脑健康")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "printing-map"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/brain.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/title-header.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "printing-header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/title-header.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "printing-map"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Mind.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Summarized-fea"
  }, [_c('p', [_vm._v("执行功能（executive function）指个体计划、面对诱惑的反应抑制能力、自我调节及监控等能力，执行功能涉及背外侧前额叶、前扣带回等。在日常学习、工作与生活中，做饭、开车、学习及工作规划等都会用到此功能。例如，出去旅游时，我们事先需要在网上或通过朋友介绍来搜集信息做乘车线路、旅游景点先后顺序等各种攻略，但是计划赶不上变化，我们有时会因为各种原因不能按原计划的线路去游玩，这时候就需要灵活调整自己的计划，以选择最有利的出游线路，这种旅游时做计划、灵活调整计划的能力就是我们讲的执行功能。数字比较测评任务\n\t\t\t\t（NumericComparison）是根据任务切换（Task-Switch）范式（Logan et al., 2003）改编的，通过计算从一个任务切换到另一个任务的反应时和正确率来检测个体的执行功能。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Rating-table"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("难度等级")]), _vm._v(" "), _c('th', [_vm._v("条件")]), _vm._v(" "), _c('th', [_vm._v("认知资源")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("数字多少与尺寸大小匹配，判断大小")]), _vm._v(" "), _c('td', [_vm._v("任务切换，知觉加工")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("数字多少与尺寸大小匹配，判断多少")]), _vm._v(" "), _c('td', [_vm._v("任务切换，抽象加工")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("数字多少与尺寸大小不匹配，判断多少")]), _vm._v(" "), _c('td', [_vm._v("任务切换和冲突抑制，知觉加工")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("数字多少与尺寸大小不匹配，判断大小")]), _vm._v(" "), _c('td', [_vm._v("任务切换和冲突抑制，抽象加工")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scene-intr"
  }, [_c('p', [_vm._v("情景记忆（Episodic Memory）是指对个人亲身经历的、发生在一定时间和地点的事件（情景）的记忆。比如，对昨天在公园里会见一位朋友的记忆就是情景记忆。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("总数")]), _vm._v(" "), _c('th', [_vm._v("正确数")]), _vm._v(" "), _c('th', {
    staticClass: "bordernone-right"
  }, [_vm._v("正确率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "age-factor"
  }, [_c('p', [_vm._v("年龄是影响情景记忆的重要因素，记忆能力随着年龄增加出现衰退。近年来利用fMRI研究青年人和老年人情景记忆的差异，认为老年人记忆力的下降在一定程度上是因为对中颞叶的利用下降，记忆衰退和海马区的激活有相关性，Cabeza 的研究小组发现在平均70岁的老年人组海马区在情景提取过程比平均年龄23岁的年轻人激活减低。缺乏运动、睡眠不足、不良生活习惯、脑疲劳或脑损伤等都会导致情景记忆减退。研究表明，运动能促进细胞内的线粒体和细胞产生能量，长期缺乏运动可能会导致大脑皮层的供养不足，脑区之间的相互连接减弱，进而导致了记忆力的下降；大脑长期处于疲劳和亚健康状态，导致的反应能力降低，也是引起执行功能下降的原因之一。此外，在事物间多进行形象化深度加工，可以有助于情景记忆的增强。例如，记忆一张老爷爷图片、地点：深圳、事件：跳舞这些信息时，可以通过联结一名时髦的老爷爷在繁华的深圳广场上跳广场舞，十分开心。总之，良好的联结记忆策略可以帮助增强情景记忆。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scene-intr"
  }, [_c('p', [_vm._v("逻辑推理（Logical Reasoning）是指一种根据周围环境和活动找出其内在的逻辑关系从而推理出符合逻辑关系的结论的能力，逻辑推理涉及背外侧前额叶、后顶叶、前扣带、脑岛等。在日常学习和生活中，经常需要用到此能力。比如，日常生活中一个人做事或说话是否有条理，就需要逻辑推理能力。逻辑推理是智力的一般因素，是与人的问题解决、清晰知觉、思维，发现和利用自己所需信息以及有效地适应社会生活的能力有关。图形推理测评任务（Figure reasoning task）选自著名的瑞文推理测验（Standard Progressive Matrices，SPM），是英国心理学家瑞文(Raven)于1938年设计的一种非文字智力测验，通过计算个体在一定时间内理性判断的正确数来检测个体的逻辑推理能力，被广泛应用于人才选拨、学业成就、智商、大脑发育水平的预测和评估中。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("难度等级")]), _vm._v(" "), _c('th', [_vm._v("认知资源")]), _vm._v(" "), _c('th', [_vm._v("总题目数")]), _vm._v(" "), _c('th', [_vm._v("正确率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carried-sport"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t深刻理解与灵活运用基础知识的能力、想象力、语言能力、情绪状态、脑疲劳或脑损伤、脑发育不良等是逻辑推理的影响因素。逻辑推理需要雄厚的知识积累，这样才能为每一步推理提供充分的依据。例如“为什么乱切的萝卜比切得整齐规则的萝卜更好煮烂、口味更好？”这个问题对一个初中生来说不知道该如何回答，而他的母亲却解释得很好。显然是因为母亲对日常生活知识的理解运用要远远强于中学生。因此，深刻理解与灵活运用基础知识的能力是个体逻辑推理能力的基础。逻辑推理有较强的灵活性和开发性，发挥想象对逻辑推理能力的提高有很大的促进作用。从多角度观察认识事物，全面地认识事物的内部与外部之间、某事物同其他事物之间的多种多样的联系，拓展自己的想象力。语言能力的好坏不仅直接影响想象力的发展，而且逻辑推理依赖于严谨的语言表达和正确的书面表达。因此，重视个体的语言培养，尤其是数学语言和几何语言的培养对个体逻辑推理能力的形成是不可或缺的关键一环。心理学研究揭示，不良的情绪会影响逻辑推理的速度和准确程度。暴怒与痛哭，持续的忧郁、烦恼与恐惧，都会对推理产生不良影响。所以，个体保持平静、轻松的情绪对逻辑推理有着重要的作用。此外，逻辑推理能力高低是由背外侧前额叶皮层、顶叶、前扣带皮层和特定的颞顶叶皮层区域的沟通效率所导致的。脑疲劳或脑损伤、脑发育不良等会引起神经活动的异常，损伤大脑皮层功能和结构，造成逻辑推理能力的不好。\n\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "QR-code"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/QR-code.jpg"),
      "alt": "六六脑官方微信"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "QR-we"
  }, [_vm._v("六六脑官方微信")]), _vm._v(" "), _c('p', {
    staticClass: "QR-we",
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("更多脑能力测评请登录"), _c('a', {
    attrs: {
      "target": "_Blank",
      "href": "http://cp.66nao.com"
    }
  }, [_vm._v("cp.66nao.com")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/page.png"),
      "alt": "图片"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f16bf2a6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reportpage.vue
// module id = 774
// module chunks = 1